import { render, staticRenderFns } from "./CampusGradeCreate.vue?vue&type=template&id=74d5110d"
import script from "../../controllers/campus_grade/campus-grade-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus_grade/campus-grade-create.js?vue&type=script&lang=js&external"
import style0 from "./CampusGradeCreate.vue?vue&type=style&index=0&id=74d5110d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports